<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <DatePicker type="month" v-model="period" format="YYYY-MM" style="width: 140px"
                    placeholder="所属期"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doCheck">开始检查</Button>
        <Button @click="doExport">导出</Button>
      </Cell>
      <Cell>
        <span class="gray-color" style="font-size: 12px;">上次检查时间：{{ checkTime || '尚未检查' }}</span>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="resultList" :border="true" :loading="loading">
        <TableItem title="#" type="number" :width="50"></TableItem>
        <TableItem title="财税项目" prop="taxItem" :width="150"></TableItem>
        <TableItem title="属期" prop="period" :width="100"></TableItem>
        <TableItem title="周期" prop="cycle" :width="90"></TableItem>
        <TableItem title="检查时间" prop="checkTime" :width="150"></TableItem>
        <TableItem title="申报状态" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="data.declareStatus === 2 ? 'h-tag-bg-green' : 'h-tag-bg-red'">
              {{ data.declareStatus === 2 ? '已申报' : '未申报' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="缴款状态" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="data.payStatus === 2 ? 'h-tag-bg-green' : 'h-tag-bg-yellow'">
              {{ data.payStatus === 2 ? '已缴款' : '未缴款' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="应补退税额" :width="120" align="right">
          <template slot-scope="{data}">{{ data.taxAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="申报期限" prop="declareDeadline" :width="110"></TableItem>
        <TableItem title="缴款期限" prop="payDeadline" :width="110"></TableItem>
        <TableItem title="漏报提示">
          <template slot-scope="{data}">
            <span :class="isMissing(data) ? 'red-color' : 'green-color'">{{ missingTip(data) }}</span>
          </template>
        </TableItem>
      </Table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

export default {
  name: 'TaxCheck',
  data() {
    return {
      period: moment().format('YYYY-MM'),
      resultList: [],
      checkTime: '',
      loading: false
    }
  },
  methods: {
    isMissing(data) {
      return data.declareStatus !== 2 || data.payStatus !== 2;
    },
    missingTip(data) {
      if (data.declareStatus !== 2) {
        return '存在漏报：尚未申报，请尽快办理申报';
      }
      if (data.payStatus !== 2) {
        return '申报已完成但尚未缴款，请及时缴款';
      }
      return '正常，无漏报';
    },
    doCheck() {
      this.loading = true;
      this.$api.tax.declare.list({period: this.period}).then(({data}) => {
        let list = data.results || data.records || data || [];
        let now = moment().format('YYYY-MM-DD HH:mm');
        this.resultList = list.map(item => Object.assign({
          period: item.period || this.period,
          cycle: item.cycle || '月报',
          checkTime: now,
          declareStatus: item.declareStatus || 0,
          payStatus: item.payStatus || 0,
          taxAmount: item.taxAmount || 0,
          declareDeadline: item.declareDeadline || '',
          payDeadline: item.payDeadline || ''
        }, item, {checkTime: now}));
        this.checkTime = now;
        if (!this.resultList.length) {
          this.$Message('当前属期暂无申报记录，请先维护申报信息~');
        }
      }).catch(() => {
        this.$Message.error('漏报检查失败');
      }).finally(() => this.loading = false);
    },
    doExport() {
      if (!this.resultList.length) {
        this.$Message.error('请先执行漏报检查~');
        return;
      }
      let headers = ['#', '财税项目', '属期', '周期', '检查时间', '申报状态', '缴款状态', '应补退税额', '申报期限', '缴款期限', '漏报提示'];
      let rows = this.resultList.map((data, index) => [
        index + 1, data.taxItem, data.period, data.cycle, data.checkTime,
        data.declareStatus === 2 ? '已申报' : '未申报',
        data.payStatus === 2 ? '已缴款' : '未缴款',
        data.taxAmount, data.declareDeadline, data.payDeadline, this.missingTip(data)
      ]);
      exportCsv(`漏报检查_${this.period}`, headers, rows);
    }
  },
  mounted() {
    this.doCheck();
  }
}
</script>
